/* pi-announcement-bar.js ============================================== */
(function () {
  function updateAnnouncementOffset() {
    const stickySection = document.querySelector('.pi-section-announcement.pi-section-announcement-sticky');
    const fixedBar = document.querySelector('pi-sticky-announcement.pi-sticky-announcement--fixed');

    let offset = 0;
    if (stickySection) {
      offset = stickySection.offsetHeight;
    } else if (fixedBar) {
      offset = fixedBar.offsetHeight;
    }

    document.documentElement.style.setProperty('--pi-sticky-announcement-offset', `${offset}px`);
    document.dispatchEvent(new CustomEvent('pi:announcement-offset-update', { detail: { offset } }));
  }

  window.piUpdateAnnouncementOffset = updateAnnouncementOffset;

  if (!window.customElements.get('pi-sticky-announcement')) {
    class PiStickyAnnouncement extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = () => {
          this.syncPlaceholder();
          updateAnnouncementOffset();
        };
      }

      connectedCallback() {
        if (this.getAttribute('data-sticky') !== 'true') return;

        this.section = this.closest('.shopify-section');
        if (!this.section) return;

        if (this.section.classList.contains('pi-section-announcement')) {
          this.section.classList.add('pi-section-announcement-sticky');
          updateAnnouncementOffset();

          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.section);
          }
          window.addEventListener('resize', this.onResize);
          return;
        }

        if (this.section.classList.contains('pi-section-header')) {
          this.mode = 'fixed';
          this.placeholder = document.createElement('div');
          this.placeholder.className = 'pi-sticky-announcement__placeholder';
          this.placeholder.setAttribute('aria-hidden', 'true');
          this.after(this.placeholder);
          this.syncPlaceholder();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this);
          }
          this.onScroll();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.section?.classList.remove('pi-section-announcement-sticky');
        this.placeholder?.remove();
        updateAnnouncementOffset();
      }

      syncPlaceholder() {
        if (!this.placeholder) return;
        this.placeholder.style.height = `${this.offsetHeight}px`;
      }

      onScroll() {
        if (this.mode !== 'fixed' || !this.placeholder) return;

        const shouldFix = this.placeholder.getBoundingClientRect().top <= 0;
        const wasFixed = this.classList.contains('pi-sticky-announcement--fixed');

        this.classList.toggle('pi-sticky-announcement--fixed', shouldFix);
        this.placeholder.style.display = shouldFix ? 'block' : 'none';

        if (shouldFix !== wasFixed) updateAnnouncementOffset();
      }
    }

    window.customElements.define('pi-sticky-announcement', PiStickyAnnouncement);
  }

  if (!window.customElements.get('pi-announcement-bar')) {
    class PiAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.slides = [];
        this.index = 0;
        this.timer = null;
        this.speed = 5000;
        this.paused = false;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.pi-announcement__slide'));
        this.speed = parseInt(this.getAttribute('data-speed'), 10) * 1000 || 5000;
        const prefersReduced =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length === 0) return;
        this.dataset.count = String(this.slides.length);
        this.slides.forEach((s, i) => {
          s.dataset.active = String(i === 0);
          s.dataset.leaving = 'false';
        });

        if (this.slides.length <= 1 || prefersReduced) return;

        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        const prev = this.querySelector('.pi-announcement__nav--prev');
        const next = this.querySelector('.pi-announcement__nav--next');
        if (prev) prev.addEventListener('click', () => this.go(-1));
        if (next) next.addEventListener('click', () => this.go(1));

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop();
        this.timer = setInterval(() => {
          if (!this.paused) this.go(1);
        }, this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      go(direction) {
        if (this.slides.length <= 1) return;
        const current = this.slides[this.index];
        const nextIndex = (this.index + direction + this.slides.length) % this.slides.length;
        const next = this.slides[nextIndex];

        current.dataset.active = 'false';
        current.dataset.leaving = 'true';
        next.dataset.active = 'true';
        next.dataset.leaving = 'false';

        setTimeout(() => {
          current.dataset.leaving = 'false';
        }, 400);

        this.index = nextIndex;
      }
    }

    window.customElements.define('pi-announcement-bar', PiAnnouncementBar);
  }
})();
